export interface Partner {
    title: string;
    logo: string;
    categorie: string;
    sub_title: string;
    description: string;
    description_full: string;
    offers: string;
    link: string;
}

export interface Video {
    description: string;
    image: string;
    link: string;
}

export interface Affiliate {
    name: string;
    code: string;
    picture: string;
    picture_style: string;
    discount: number;
    condition: string;
    duration: string;
    commission: number;
    anonym: boolean;
}

export const AFFILIATE: Affiliate[] = [
    {
        name: 'Axel Paris',
        code: 'AXELPARIS',
        picture: 'assets/axelparis.jpg',
        picture_style: '',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Bye bye patron',
        code: 'BYEBYEPATRON',
        picture: 'assets/byebyepatron.webp',
        picture_style: '',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Club des rentier',
        code: 'CDR',
        picture: 'assets/CDR.jpg',
        picture_style: '',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Cedric berthelon',
        code: 'CEDRICBERTHELON',
        picture: 'assets/cedricberthelon.png',
        picture_style: '',
        discount: 10,
        condition: '',
        duration: 'Remise valable pendant 1 an',
        commission: 10,
        anonym: false,
    },
    {
        name: 'Meilleurs formations immobilier',
        code: 'MFI',
        picture: 'assets/mfi.jpeg',
        picture_style: '',
        discount: 0,
        condition: '',
        duration: '',
        commission: 40,
        anonym: false,
    },
    {
        name: 'Monsieur Hugo',
        code: 'MONSIEURHUGO',
        picture: 'assets/monsieurhugo.png',
        picture_style: '',
        discount: 10,
        condition: '',
        duration: 'Remise valable pendant 1 an',
        commission: 10,
        anonym: false,
    },
    {
        name: 'Les clés de l\'immobilier',
        code: 'SEBASTIENFEUCHOT',
        picture: 'assets/logo-lesclesdelimmobilier.png',
        picture_style: '',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'J\'ai investi dans la pierre',
        code: 'TEAM_ELITE',
        picture: 'assets/jaiinvestidanslapierre.png',
        picture_style: 'border-radius: 50%;',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Daniel VU',
        code: 'DANIELVU',
        picture: 'assets/daniel-vu.jpg',
        picture_style: 'border-radius: 50%;',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Le cercle des investisseurs',
        code: 'LECERCLE',
        picture: 'assets/lecercledesinvestisseurs.jpeg',
        picture_style: '',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'La fabrique des investisseurs',
        code: 'LFDI',
        picture: 'assets/lafabriquedesinvestisseurs.jpeg',
        picture_style: '',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Monsieur Libre',
        code: 'MONSIEURLIBRE',
        picture: 'assets/Logo Monsieur Libre.png',
        picture_style: '',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Evermind',
        code: 'EVERMIND',
        picture: 'assets/evermind.png',
        picture_style: '',
        discount: 10,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 10,
        anonym: false,
    },
    {
        name: 'Sebastien Ascon',
        code: 'SEBASTIENASCON',
        picture: 'assets/sebastienascon.png',
        picture_style: '',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Immonetiz',
        code: 'IMMONETIZ',
        picture: 'assets/immonetiz.PNG',
        picture_style: '',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Joris Crouzil',
        code: 'MERAXIA',
        picture: 'assets/JorisCrouzil.png',
        picture_style: '',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Sebastien MORE',
        code: 'SEBMORE',
        picture: 'assets/logo-sebastienmore.png',
        picture_style: '',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Rémy Pampin',
        code: 'REMYPAMPIN',
        picture: 'assets/RemyPampin.jpeg',
        picture_style: 'border-radius:50%;',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Thomas Creton',
        code: 'THOMASCRETON',
        picture: 'assets/investir-simple.png',
        picture_style: 'border-radius:20px;',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Julien Delagrandanne',
        code: 'DELAGRANDANNE20',
        picture: 'assets/logo-DELAGRANDANNE.jpg',
        picture_style: 'border-radius:20px;',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'La Martingale',
        code: 'LAMARTINGALE',
        picture: 'assets/LaMartingale-Logo-1.png',
        picture_style: '',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 1 an',
        commission: 0,
        anonym: false,
    },
    {
        name: 'YL38SU72', // Webminer
        code: 'YL38SU72',
        picture: '',
        picture_style: '',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: true,
    },
    {
        name: 'la chasseur immo académie',
        code: 'CIA',
        picture: 'assets/cia.png',
        picture_style: '',
        discount: 10,
        condition: '',
        duration: '',
        commission: 10,
        anonym: false,
    },
    {
        name: 'Immo pro',
        code: 'RC20',
        picture: 'assets/immopro.jpeg',
        picture_style: 'border-radius:50%;',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Esprit immo',
        code: 'ESPRITIMMO',
        picture: '',
        picture_style: '',
        discount: 0,
        condition: '',
        duration: '',
        commission: 20,
        anonym: true,
    },
    {
        name: 'Focus and you',
        code: 'FOCUSANDYOU',
        picture: 'assets/Logo_focusandyou.png',
        picture_style: 'border-radius:50%;',
        discount: 20,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Immo compare',
        code: 'IMMOCOMPARE',
        picture: 'https://immocompare.org/wp-content/uploads/2023/02/Logo_Immo-removebg.png',
        picture_style: '',
        discount: 10,
        condition: '',
        duration: '',
        commission: 10,
        anonym: false,
    },
    {
        name: 'Tony Jazz',
        code: 'TONY',
        picture: 'assets/tony.jpg',
        picture_style: 'border-radius:50%;',
        discount: 0,
        condition: '',
        duration: '',
        commission: 0,
        anonym: false,
    },
    {
        name: 'Oseille TV',
        code: 'OSEILLETV',
        picture: '',
        picture_style: '',
        discount: 0,
        condition: '',
        duration: '',
        commission: 20,
        anonym: true,
    },
    {
        name: 'Medhi Asten',
        code: 'ASTEN',
        picture: 'assets/logo_medhiasten.png',
        picture_style: 'border-radius:50%;',
        discount: 0,
        condition: '',
        duration: '',
        commission: 20,
        anonym: true,
    },
    {
        name: 'Numero 102',
        code: 'NUMERO102',
        picture: 'assets/logo_numero102.jpg',
        picture_style: 'border-radius:50%;',
        discount: 50,
        condition: 'sur votre 1er mois',
        duration: 'Offre valable sur votre 1er mois',
        commission: 0,
        anonym: false,
    },
    {
        name: 'Sonia Deram',
        code: 'SONIA10',
        picture: 'assets/SoniaDeram.jpg',
        picture_style: 'border-radius:50%;',
        discount: 10,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 10,
        anonym: false,
    },
    {
        name: 'OWNRS',
        code: 'OWNRS',
        picture: 'assets/OWNRS.png',
        picture_style: 'border-radius:50%;',
        discount: 50,
        condition: 'sur votre 1er mois',
        duration: 'Offre valable sur votre 1er mois',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Thomas creton',
        code: 'IVS',
        picture: 'assets/investir-simple.png',
        picture_style: 'border-radius:50%;',
        discount: 50,
        condition: 'sur votre 1er mois',
        duration: 'Offre valable sur votre 1er mois',
        commission: 0,
        anonym: false,
    },
    {
        name: 'Les investisseurs 4.0',
        code: 'LESINVESTISSEURS40',
        picture: 'assets/invest40.webp',
        picture_style: 'border-radius:5%;',
        discount: 50,
        condition: 'sur votre 1er mois',
        duration: 'Offre valable sur votre 1er mois',
        commission: 20,
        anonym: false,
    },
    {
        name: 'L\'éducation financière',
        code: 'EDUCATIONFINANCIERE',
        picture: 'assets/pdf/leducationfinanciere/EF1.png',
        picture_style: '',
        discount: 0,
        condition: '',
        duration: '',
        commission: 20,
        anonym: false,
    },
    {
        name: 'instantcashflow',
        code: 'INSTANTCASHFLOW',
        picture: '',
        picture_style: 'border-radius:50%;',
        discount: 0,
        condition: '',
        duration: '',
        commission: 20,
        anonym: true,
    },
    {
        name: 'Patrimoine pour tous',
        code: 'PPT',
        picture: '',
        picture_style: 'border-radius:50%;',
        discount: 0,
        condition: '',
        duration: '',
        commission: 20,
        anonym: true,
    },
    {
        name: 'QLower',
        code: 'QLOWER',
        picture: '',
        picture_style: 'border-radius:50%;',
        discount: 0,
        condition: '',
        duration: '',
        commission: 20,
        anonym: true,
    },
    {
        name: 'Immo invest cafe',
        code: 'IMMOINVESTCAFE',
        picture: '',
        picture_style: 'border-radius:50%;',
        discount: 0,
        condition: '',
        duration: '',
        commission: 20,
        anonym: true,
    },
    {
        name: 'Yass immo',
        code: 'YASS',
        picture: '',
        picture_style: 'border-radius:50%;',
        discount: 0,
        condition: '',
        duration: '',
        commission: 20,
        anonym: true,
    },
    {
        name: 'Clément Canovas',
        code: 'CLEMENTCANOVAS',
        picture: '',
        picture_style: 'border-radius:50%;',
        discount: 0,
        condition: '',
        duration: '',
        commission: 20,
        anonym: true,
    },
    {
        name: 'Greg Immo',
        code: 'GREGIMMO',
        picture: '',
        picture_style: 'border-radius:50%;',
        discount: 100,
        condition: 'sur votre 1er mois',
        duration: 'Offre valable sur votre 1er mois',
        commission: 20,
        anonym: true,
    },
    {
        name: 'JM Academie',
        code: 'JM',
        picture: 'assets/jm.png',
        picture_style: 'background-color: white;',
        discount: 100,
        condition: 'sur votre 1er mois',
        duration: 'Offre valable sur votre 1er mois',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Pauline',
        code: 'PAULINE',
        picture: 'assets/pauline.png',
        picture_style: '',
        discount: 100,
        condition: 'sur votre 1er mois',
        duration: 'Offre valable sur votre 1er mois',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Rémi Roche',
        code: 'IMMOAC',
        picture: 'assets/remi-roche.png',
        picture_style: '',
        discount: 10,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 10,
        anonym: false,
    },
    {
        name: 'Théo Vasquez',
        code: 'THEO',
        picture: 'assets/theo.jpg',
        picture_style: 'border-radius: 50%;',
        discount: 100,
        condition: 'sur votre 1er mois',
        duration: 'Offre valable sur votre 1er mois',
        commission: 20,
        anonym: false,
    },
    {
        name: 'SUPERHOTE',
        code: 'SUPERHOTE',
        picture: 'assets/superhote.png',
        picture_style: '',
        discount: 50,
        condition: 'sur votre 1er mois',
        duration: 'Offre valable sur votre 1er mois',
        commission: 20,
        anonym: false,
    },
    {
        name: 'MPI',
        code: 'MPI',
        picture: 'assets/LOGO MPI VF.png',
        picture_style: '',
        discount: 10,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 10,
        anonym: false,
    },
    {
        name: 'MMI',
        code: 'MMI',
        picture: 'assets/logo mmi.png',
        picture_style: '',
        discount: 10,
        condition: '',
        duration: 'Remise valable pendant 6 mois ou 1 an pour les abonnements annuels',
        commission: 10,
        anonym: false,
    },
    {
        name: 'LEARNIMMO',
        code: 'LEARNIMMO',
        picture: 'assets/learn-immo_logo_original_white_bg.png',
        picture_style: '',
        discount: 50,
        condition: 'sur votre 1er mois',
        duration: 'Offre valable sur votre 1er mois',
        commission: 20,
        anonym: false,
    },
    {
        name: 'QALIMO',
        code: 'QALIMO',
        picture: 'assets/qalimo.png',
        picture_style: '',
        discount: 50,
        condition: 'sur votre 1er mois',
        duration: 'Offre valable sur votre 1er mois',
        commission: 20,
        anonym: false,
    },
    {
        name: 'Florian Bonny',
        code: 'FLORIANBONNY',
        picture: 'assets/logo-FLORIANBONNY.jpeg',
        picture_style: '',
        discount: 50,
        condition: 'sur votre 1er mois',
        duration: 'Offre valable sur votre 1er mois',
        commission: 20,
        anonym: false,
    },
];
